export default __webpack_public_path__ + "static/media/firm-office-marker.0e0bec4a.svg";